import { createContext } from "react";

import type { Settings } from "../../types/settings";

export const defaultSettings: Settings = {
  colorPreset: "blue",
  contrast: "normal",
  direction: "ltr",
  layout: "vertical",
  navColor: "discrete",
  paletteMode: "dark",
  responsiveFontSizes: true,
  stretch: true,
};

export interface State extends Settings {
  openDrawer: boolean;
  isInitialized: boolean;
}

export const initialState: State = {
  ...defaultSettings,
  isInitialized: false,
  openDrawer: false,
};

export interface SettingsContextType extends State {
  handleDrawerClose: () => void;
  handleDrawerOpen: () => void;
  handleReset: () => void;
  handleUpdate: (settings: Settings) => void;
  isCustom: boolean;
}

export const SettingsContext = createContext<SettingsContextType>({
  ...initialState,
  handleDrawerClose: () => {
    // no-op
  },
  handleDrawerOpen: () => {
    // no-op
  },
  handleReset: () => {
    // no-op
  },
  handleUpdate: () => {
    // no-op
  },
  isCustom: false,
});
